import { declineAdvancementModuleSel } from '../../common';

const moduleSel = state => declineAdvancementModuleSel(state);
export const isLoadingAdvancementRequestSel = state =>
  moduleSel(state).isLoadingAdvancementRequest;
export const advancementsToDeclineSel = state =>
  moduleSel(state).advancementsToDecline;
